import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NgIf } from '@angular/common';
import { MenuItem } from '../../core/models/menu.model';
import { DataService } from '../../core/services/data.service';
import { ImgSlotComponent } from './img-slot.component';
import { TagComponent } from './tag.component';
import { PriceComponent } from './price.component';
import { SoldOutVeilComponent } from './sold-out-veil.component';
import { TranslatePipe } from '../pipes/translate.pipe';

/** Horizontal "best seller" card (fixed width, for horizontal rails). */
@Component({
  selector: 'app-item-card',
  standalone: true,
  imports: [NgIf, ImgSlotComponent, TagComponent, PriceComponent, SoldOutVeilComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<div (click)="open.emit(item)"
      style="width:168px;flex-shrink:0;cursor:pointer;background:var(--fr-surface);border-radius:16px;
             box-shadow:var(--fr-shadow-sm);overflow:hidden;border:1px solid var(--fr-border)">
      <app-img-slot [src]="photo" [tone]="item.tone" [radius]="0" style="height:116px;width:100%">
        <app-sold-out-veil *ngIf="item.soldout"></app-sold-out-veil>
        <div style="position:absolute;top:8px;inset-inline-start:8px;display:flex;gap:4px">
          <app-tag *ngIf="item.tags.includes('best')" kind="best"></app-tag>
          <app-tag *ngIf="item.tags.includes('new') && !item.tags.includes('best')" kind="new"></app-tag>
        </div>
      </app-img-slot>
      <div style="padding:10px 11px 12px">
        <div style="font-weight:700;font-size:14px;letter-spacing:-0.01em;line-height:1.2;color:var(--fr-text);min-height:34px">{{ item.name }}</div>
        <div style="display:flex;align-items:center;justify-content:space-between;margin-top:8px">
          <app-price [value]="item.price" [size]="15"></app-price>
          <span *ngIf="qty > 0" class="fr-num"
            style="min-width:24px;height:24px;padding:0 7px;border-radius:12px;background:var(--brand-tint);
                   color:var(--brand-deep);font-size:12.5px;font-weight:750;display:flex;align-items:center;justify-content:center">{{ qty }} {{ 'in cart' | t }}</span>
        </div>
      </div>
    </div>`,
})
export class ItemCardComponent {
  @Input() item!: MenuItem;
  @Input() qty = 0;
  @Output() open = new EventEmitter<MenuItem>();

  constructor(private data: DataService) {}
  get photo(): string | null { return this.data.photoFor(this.item.id); }
}
